// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3052":"7c56d87a","6561":"27ae889f"}[chunkId] + ".chunk.css";
};